/*
 *
 * messaging constants
 *
 */
export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const GET_ADVISER_LIST_REQUESTED = "msg/GET_ADVISER_LIST_REQUESTED";
export const GET_ADVISER_LIST_SUCCESS = "msg/GET_ADVISER_LIST_SUCCESS";
export const GET_ADVISER_LIST_FAILED = "msg/GET_ADVISER_LIST_FAILED";

export const GET_CATEGORY_LIST_REQUESTED = "app/GET_CATEGORY_LIST_REQUESTED";
export const GET_CATEGORY_LIST_SUCCESS = "app/GET_CATEGORY_LIST_SUCCESS";
export const GET_CATEGORY_LIST_FAILED = "app/GET_CATEGORY_LIST_FAILED";

export const GET_CONTACT_LIST_REQUESTED = "app/GET_CONTACT_LIST_REQUESTED";
export const GET_CONTACT_LIST_SUCCESS = "app/GET_CONTACT_LIST_SUCCESS";
export const GET_CONTACT_LIST_FAILED = "app/GET_CONTACT_LIST_FAILED";

export const GET_INBOX_CHAT_LIST_REQUESTED = "app/GET_INBOX_CHAT_LIST_REQUESTED";
export const GET_INBOX_CHAT_LIST_SUCCESS = "app/GET_INBOX_CHAT_LIST_SUCCESS";
export const GET_INBOX_CHAT_LIST_FAILED = "app/GET_INBOX_CHAT_LIST_FAILED";

export const GET_SEND_CHAT_LIST_REQUESTED = "app/GET_SEND_CHAT_LIST_REQUESTED";
export const GET_SEND_CHAT_LIST_SUCCESS = "app/GET_SEND_CHAT_LIST_SUCCESS";
export const GET_SEND_CHAT_LIST_FAILED = "app/GET_SEND_CHAT_LIST_FAILED";

export const GET_ARCHIVE_CHAT_LIST_REQUESTED = "app/GET_ARCHIVE_CHAT_LIST_REQUESTED";
export const GET_ARCHIVE_CHAT_LIST_SUCCESS = "app/GET_ARCHIVE_CHAT_LIST_SUCCESS";
export const GET_ARCHIVE_CHAT_LIST_FAILED = "app/GET_ARCHIVE_CHAT_LIST_FAILED";

export const SEND_MESSAGE_REQUESTED = "app/SEND_MESSAGE_REQUESTED";
export const SEND_MESSAGE_SUCCESS = "app/SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILED = "app/SEND_MESSAGE_FAILED";

export const GET_HAMRAZ_HISTORY_REQUESTED = "app/GET_HAMRAZ_HISTORY_REQUESTED";
export const GET_HAMRAZ_HISTORY_SUCCESS = "app/GET_HAMRAZ_HISTORY_SUCCESS";
export const GET_HAMRAZ_HISTORY_FAILED = "app/GET_HAMRAZ_HISTORY_FAILED";

export const SET_HAMRAZ_HISTORY_DATA = "app/SET_HAMRAZ_HISTORY_DATA";

export const SEND_AND_REMOVE_MESSAGE_REQUESTED = "app/SEND_AND_REMOVE_MESSAGE_REQUESTED";
export const SEND_AND_REMOVE_MESSAGE_SUCCESS = "app/SEND_AND_REMOVE_MESSAGE_SUCCESS";
export const SEND_AND_REMOVE_MESSAGE_FAILED = "app/SEND_AND_REMOVE_MESSAGE_FAILED";

export const SEND_AND_ARCHIVE_MESSAGE_REQUESTED = "app/SEND_AND_ARCHIVE_MESSAGE_REQUESTED";
export const SEND_AND_ARCHIVE_MESSAGE_SUCCESS = "app/SEND_AND_ARCHIVE_MESSAGE_SUCCESS";
export const SEND_AND_ARCHIVE_MESSAGE_FAILED = "app/SEND_AND_ARCHIVE_MESSAGE_FAILED";

export const SET_TAG_MESSAGE_REQUESTED = "app/SET_TAG_MESSAGE_REQUESTED";
export const SET_TAG_MESSAGE_SUCCESS = "app/SET_TAG_MESSAGE_SUCCESS";
export const SET_TAG_MESSAGE_FAILED = "app/SET_TAG_MESSAGE_FAILED";

export const SEEN_MESSAGE_REQUESTED = "app/SEEN_MESSAGE_REQUESTED";
export const SEEN_MESSAGE_SUCCESS = "app/SEEN_MESSAGE_SUCCESS";
export const SEEN_MESSAGE_FAILED = "app/SEEN_MESSAGE_FAILED";

export const SET_MESSAGE = "app/SET_MESSAGE";

export const TOGGLE_SHOW_MESSAGE_DIALOG = "app/TOGGLE_SHOW_MESSAGE_DIALOG";

export const REMOVE_CONTACT_REQUESTED = "app/REMOVE_CONTACT_REQUESTED";
export const REMOVE_CONTACT_SUCCESS = "app/REMOVE_CONTACT_SUCCESS";
export const REMOVE_CONTACT_FAILED = "app/REMOVE_CONTACT_FAILED";

export const SET_PAGE_TARGET = "app/SET_PAGE_TARGET";

export const SET_NEW_MESSAGES_COUNT = "app/SET_NEW_MESSAGES_COUNT";

export const SET_OPEN_CONSULTANT_DIALOG = "app/SET_OPEN_CONSULTANT_DIALOG";

export const SET_OPEN_MESSAGE_DIALOG = "app/SET_OPEN_MESSAGE_DIALOG";
